import React from 'react';
import { makeStyles } from '@mui/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Paper from '@mui/material/Paper';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Alert } from '@mui/material';
import Collapse from '@mui/material/Collapse';
import Copyright from './copyright';
import CircularProgress from '@mui/material/CircularProgress';

import clienteAxios from '../Config/axios';
import IngresaClave from './etapa2/IngresaClave';
import Resultado from './etapa2/Resultado';
import validaPolitica from '../utils/politicaClave';


import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#3f51b5',
    }
  },
});

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
  },
  layout: {
    width: 'auto',
    marginLeft: useTheme().spacing(2),
    marginRight: useTheme().spacing(2),
    [useTheme().breakpoints.up('md')]: {
      width: 600,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: useTheme().spacing(3),
    marginBottom: useTheme().spacing(3),
    padding: useTheme().spacing(2),
    [useTheme().breakpoints.up('md')]: {
      marginTop: useTheme().spacing(1),
      marginBottom: useTheme().spacing(6),
      padding: useTheme().spacing(3),
    },
  },
  stepper: {
    padding: useTheme().spacing(3, 0, 1),
    color: '#3f51b5',
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: useTheme().spacing(2),
  },
  button: {
    marginTop: useTheme().spacing(3),
    marginLeft: useTheme().spacing(1),
    color: '#3f51b5',
  },
  fondo: {
    backgroundColor: '#000',
    height: '100vh',
    display: 'block',
    backgroundImage: "url('../images/background.jpg')"
  },
  footer: {
    color: 'white'
  },
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: useTheme().spacing(2),
    },
    marginBottom: useTheme().spacing(3),
  },
  loading: {
    display: 'flex',
    '& > * + *': {
      marginLeft: useTheme().spacing(2),
    },
  }
}));

const steps = ['Verificación de link', 'Cambiar clave', 'Resultado'];
export default function Etapa2() {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const [token, setToken] = React.useState('');
  const [viewAlert, setAlert] = React.useState({ show: false, message: '' });
  const [clave, setClave] = React.useState('');
  const [clave_rep, setClave_rep] = React.useState('');
  const [loading, setLoading] = React.useState(false);

  const handleNext = () => {
    if (activeStep === 1) {
      if (validaClave()) {
        enviaClave()
      }
    }
  }

  const leerClave = e => {
    setClave(e.target.value)
  }

  const leerClave_rep = e => {
    setClave_rep(e.target.value)
  }

  const validaToken = async () => {
    setLoading(true)
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const tk = params.get('tk');
    if (tk) {
      try {
        let response = await clienteAxios.get(`/api/usuarios/token/${tk}`)
        setToken(response.data.token)
        setActiveStep(1)
      } catch (error) {
        setActiveStep(-1)
        if (error.response) {
          setAlert({ show: true, message: 'Acceso no autorizado, el link se encuentra expirado. Por favor realizar nuevamente el proceso' })
        } else {
          setAlert({ show: true, message: 'Ha ocurrido un error, pronto lo solucionaremos' })
        }
      }
    } else {
      setActiveStep(-1)
      setAlert({ show: true, message: 'Acceso no autorizado, sin verificación. Revisa tu correo e ingresa al link nuevamente o vuelve a realizar el proceso' })
    }
    setLoading(false)
  };
 
  const validaClave = () => {
    const motivoRechazo = validaPolitica(clave)
    if (motivoRechazo) {
      setAlert({ show: true, message: motivoRechazo })
      return false
    }
    if (clave !== clave_rep) {
      setAlert({ show: true, message: 'Las claves no coinciden' })
      return false
    }
    setAlert({ show: false, message: '' })
    return true
  };

  const enviaClave = async () => {
    try {
      setLoading(true)
      const config = {
        headers: { Authorization: `Bearer ${token}` }
      };
      await clienteAxios.post(`/api/usuarios`, { password: clave, password_r: clave_rep }, config)
      setActiveStep(2)
    } catch (error) {
      if (error.response) {
        /* el token venció o no es válido: la única salida es reiniciar el proceso */
        if (error.response.status === 401 || error.response.status === 403) {
          setActiveStep(-1)
        }
        /* cualquier otro rechazo del servidor (por ejemplo, una clave presente en
           la BD de claves filtradas) se muestra en este mismo paso para que el
           usuario pueda corregir la clave sin volver a pedir el correo */
        setAlert({
          show: true,
          message: error.response.data && error.response.data.message
            ? error.response.data.message
            : 'La nueva clave no cumple con la política de seguridad. Intenta con otra clave'
        })
      } else {
        setActiveStep(-1)
        setAlert({ show: true, message: 'Ha ocurrido un error, pronto lo solucionaremos. Intenta ingresando más tarde' })
      }
    } finally {
      setLoading(false)
    }
  }

  return <ThemeProvider theme={theme}>
    <div className={classes.fondo}>
      <React.Fragment>
        <CssBaseline />
        <main className={classes.layout}>
          <Box mx="auto" p={1} align="center">
            <img src={"images/logo_blanco.png"} alt="logo USS" />
          </Box>
          <Paper className={classes.paper}>
            <div>
              <Box mx="auto" p={3} align="center">
                <img src={"images/logo_claveunica.svg"} alt="logo USS" width="250px" />
              </Box>
            </div>
            <Typography variant="body2" m={2} gutterBottom>
              Recuerda que esta clave te servirá para ingresar a todos los servicios de la Universidad San Sebastián de manera fácil y segura.
            </Typography>
            {activeStep !== -1 && (
              <Stepper activeStep={activeStep} className={classes.stepper}>
                {steps.map((label, index) => (
                  <Step key={label}>
                    <StepLabel icon={index + 4}>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
            )}

            {loading === true && (
              <div className={classes.loading}>
                <Box mx="auto" align="center">
                  <CircularProgress />
                </Box>
              </div>
            )}

            <div className={classes.root}>
              <Collapse in={viewAlert.show}>
                <Alert severity="error">{viewAlert.message}</Alert>
              </Collapse>
            </div>
          
            {loading === false && (
              <React.Fragment>
                <React.Fragment>
                  {
                    (() => {
                      switch (activeStep) {
                        case -1:
                          return ''
                        case 0:
                          if (!token) {
                            validaToken();
                          }
                          break
                        case 1:
                          return <IngresaClave
                            clave={clave}
                            leerClave={leerClave}
                            leerClave_rep={leerClave_rep}
                          />;
                        case 2:
                          return <Resultado />
                        default:
                          throw new Error('Unknown step');
                      }
                    }).call(this)
                  }
                  <div className={classes.buttons}>
                    {activeStep === 1 && (
                      <Button
                        variant="contained"
                        onClick={handleNext}
                        className={classes.button}
                        sx={{
                          mt: 2,
                          ml: 2
                        }}
                      >
                        Siguiente
                      </Button>
                    )}

                    {activeStep === -1 && (
                      <Button
                        variant="contained"
                        href="/"
                        className={classes.button}
                        sx={{
                          mt: 2,
                          ml: 2
                        }}
                      >
                        Volver a realizar el proceso
                      </Button>
                    )}
                  </div>
                </React.Fragment>
              </React.Fragment>
            )}
          </Paper>
          <Copyright />
        </main>
      </React.Fragment>
    </div>
      </ThemeProvider>;
}
